<!-- WAREHOUSE LIST -->
<div class="page-header">
  <div class="header-row">
    <div></div><!-- spacer to push actions to the right -->
    <!-- Page Actions -->
    <div class="page-actions">
      <!-- Export Button -->
      <!-- <button class="btn btn-secondary" (click)="exportWarehouses()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
        </svg>
        Export
      </button> -->

      <!-- Add Warehouse Button -->
      <button class="btn btn-primary" (click)="addWarehouse()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        Add Warehouse
      </button>
    </div>
  </div>
</div>
<div class="warehouse-list-container">
  <!-- Removed legacy spinner in favor of Skeleton UX -->

  <!-- Table Wrapper -->
  <div class="table-wrapper">
    <div class="table-scroll-container">
      <table class="warehouse-table">
        <thead>
          <tr>
            <th class="col-row">#</th>
            <th class="col-name">Warehouse Name</th>
            <th class="col-address">Address</th>
            <th class="col-contact">Contact Name</th>
            <th class="col-email">Email</th>
            <th class="col-phone">Ph Number</th>
            <th class="col-alt-phone">Alternate Ph</th>
            <!-- <th class="col-status">Status</th> -->
            <th class="col-actions">Actions</th>
          </tr>
        </thead>
        <tbody *ngIf="!isLoading || warehouseData?.length > 0">
          <tr *ngFor="let item of warehouseData; let i = index">
            <!-- Row Number -->
            <td class="col-row">{{ item.sNo }}</td>

            <!-- Warehouse Name -->
            <td class="col-name">{{item.warehouse_name }}</td>

            <!-- Address -->
            <td class="col-address">{{ item?.address?.address}}</td>

            <!-- Contact Name -->
            <td class="col-contact">{{ item.contact_name }}</td>

            <!-- Email -->
            <td class="col-email">{{item.email }}</td>

            <!-- Phone Number (Clickable) -->
            <td class="col-phone">
              <a *ngIf="hasPhone( item.phone); else noPhone" [href]="'tel:' + formatPhoneForTel(item.phone)"
                class="phone-link" [title]="'Call ' + item.country_code+item.phone">
                {{ item.country_code }}{{ item.phone }}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
              </a>
              <ng-template #noPhone>{{ item.phone }}</ng-template>
            </td>

            <!-- Alternate Phone (Clickable) -->
            <td class="col-alt-phone">
              <a *ngIf="hasPhone(item.alt_phone); else noAltPhone" [href]="'tel:' + formatPhoneForTel(item.alt_phone)"
                class="phone-link" [title]="'Call ' + item.country_code + item.alt_phone">

                {{ item.country_code }}{{ item.alt_phone }}

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
              </a>

              <!-- ❌ Invalid / null phone -->
              <ng-template #noAltPhone>
                --
              </ng-template>
            </td>


            <!-- Status Badge -->
            <!-- <td class="col-status">
              <span class="status-badge" [class.active]="item.is_main_localation"
                [class.inactive]="!item.is_main_localation">
                <span class="status-dot"></span>
                {{ item?.is_main_localation ? 'Active' : 'Inactive' }}
              </span>
            </td> -->

            <!-- Action Buttons -->
            <td class="col-actions">
              <div class="action-buttons">
                <!-- Toggle Active/Inactive -->
                <button class="action-btn toggle-btn" [class.active]="item.is_main_localation"
                  (click)="warehouseSet(item.id, !item.is_main_localation)"
                  [title]="item.is_main_localation ? 'Deactivate' : 'Activate'">
                  <svg *ngIf="item.is_main_localation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                      clip-rule="evenodd" />
                  </svg>
                  <svg *ngIf="!item.is_main_localation" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </button>

                <!-- Edit Button -->
                <button class="action-btn edit-btn" (click)="editWarehouse(item.id)" title="Edit">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                  </svg>
                </button>

                <!-- Delete Button -->
                <button class="action-btn delete-btn" (click)="deleteOrder(item.id)" title="Delete">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z"
                      clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="warehouseData?.length === 0">
            <td colspan="5" style="text-align: center; padding: 40px; color: #9ca3af;">
              <svg class="nav-icon" fill="currentColor" viewBox="0 0 20 20">
                <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" />
                <path fill-rule="evenodd"
                  d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
                  clip-rule="evenodd" />
              </svg>
              <div style="font-size: 16px; font-weight: 500; margin-bottom: 4px;">No warehouse found</div>
              <div style="font-size: 14px;">Try adjusting your search or filters</div>
            </td>
          </tr>
        </tbody>

        <!-- Skeleton Rows -->
        <tbody *ngIf="isLoading && (!warehouseData || warehouseData.length === 0)">
          <tr *ngFor="let item of [1,2,3,4,5,6,7,8,9,10]">
            <td class="col-row"><div class="skeleton-line" style="width: 20px;"></div></td>
            <td class="col-name"><div class="skeleton-line full"></div></td>
            <td class="col-address"><div class="skeleton-line full"></div></td>
            <td class="col-contact"><div class="skeleton-line full"></div></td>
            <td class="col-email"><div class="skeleton-line full"></div></td>
            <td class="col-phone"><div class="skeleton-line full"></div></td>
            <td class="col-alt-phone"><div class="skeleton-line full"></div></td>
            <td class="col-actions">
              <div class="action-buttons">
                <div class="skeleton-icon-btn"></div>
                <div class="skeleton-icon-btn"></div>
                <div class="skeleton-icon-btn"></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Footer -->
    <div class="pagination-footer">
      <div class="pagination-controls">
        <button class="nav-arrow" (click)="previousPage()" [disabled]="!canGoPrevious">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>

        <div class="pagination-info">
          {{ paginationInfo }}
        </div>

        <button class="nav-arrow" (click)="nextPage()" [disabled]="!canGoNext">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
          </svg>
        </button>
      </div>
    </div>
  </div>

</div>